module.exports = __webpack_public_path__ + "static/media/11d.6c1a1d95.png";